import { Box, CustomModalLayout } from '@wix/design-system';
import React from 'react';
import { PlanFeatures } from '../PlanFeatures';
export const PlanFeaturesModalContent = _ref => {
  let {
    productId,
    title,
    t,
    Trans,
    subtitle,
    footer,
    primaryButtonText,
    onClose,
    onError,
    dataHook
  } = _ref;
  return /*#__PURE__*/React.createElement(CustomModalLayout, {
    dataHook: dataHook,
    maxHeight: "700px",
    showFooterDivider: true,
    onCloseButtonClick: onClose,
    title: title,
    subtitle: subtitle,
    primaryButtonText: primaryButtonText ?? t('change_plan.current_plan_modal.close'),
    primaryButtonOnClick: onClose
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(PlanFeatures, {
    productId: productId,
    t: t,
    Trans: Trans,
    onError: onError
  }), footer));
};
//# sourceMappingURL=PlanFeaturesModalContent.js.map